export default __webpack_public_path__ + "static/media/boy3.b0e26b6c.png";